export default __webpack_public_path__ + "static/greybg-91a8111fd7d44d8955c239d1ff52fd77.mp4";